import { FieldHookConfig, useField } from "formik";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { TextFieldProps } from "@mui/material/TextField/TextField";
import { Box } from "@mui/material";

import AppLabel from "./AppLabel";
import { CustomFormProps } from "../../types/components/Form";

const AppTextField = styled(
  (props: TextFieldProps & FieldHookConfig<string> & CustomFormProps) => {
    const [field, meta] = useField(props);
    const errorText = meta.error && meta.touched ? meta.error : "";

    return (
      <Box sx={{ marginBottom: "10px" }}>
        <AppLabel
          htmlFor={props.name}
          color={props.themeColor === "dark" ? "white" : "black"}
        >
          {props.label}
        </AppLabel>
        <TextField
          {...props}
          {...field}
          label=""
          fullWidth
          variant="outlined"
          helperText={errorText}
          error={!!errorText}
        />
      </Box>
    );
  }
)(({ theme }) => ({
  "& .MuiInputBase-root": {
    border: "1px solid #6b6f7d",
    borderRadius: "10px",
  },
  "& .Mui-focused fieldset": {
    border: "1px solid #ffffff",
  },
  "& .MuiInputBase-input": {
    color: "#999",
  },
  "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[200],
  },
}));

export default AppTextField;
